<div class="pt-20 sm:pt-24 md:pt-28 lg:pt-32">
  <!-- <shared-type-establishment-bar></shared-type-establishment-bar> -->
    @defer (on immediate) {
  <shared-categories-establishment></shared-categories-establishment>
    }

  <div class="container mx-auto px-4 py-4">
    <shared-arrow-back></shared-arrow-back>
    <features-establishemnts-general
      [establishments]="establishments()"
      [isLoading]="isLoading"
      (visitClick)="navigateToProducts($event)"
    ></features-establishemnts-general>
  </div>
</div>
